module.exports = __webpack_public_path__ + "img/cloudflare-1.f7902e6d.jpg";